export default function(Handlebars) {
  /* istanbul ignore next */
  let root = typeof global !== 'undefined' ? global : window,
    $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function() {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
}



// WEBPACK FOOTER //
// ../../../lib/handlebars/no-conflict.js